import { defineComponent as _defineComponent } from 'vue'
import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, unref as _unref, createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, renderSlot as _renderSlot, resolveDynamicComponent as _resolveDynamicComponent, createElementVNode as _createElementVNode, createSlots as _createSlots } from "vue"

import { computed, PropType, ref } from 'vue';
import { VAFormItem } from './extends/typing';
import VASelect from '../VASelect/VASelect';
import VASelectCascade from '../VASelectCascade/VASelectCascade';
import VASwitch from '../VASwitch/VASwitch.vue';
import VARadioGroup from '../VARadioGroup/VARadioGroup.vue';
import VAInputNumber from '../VAInputNumber/VAInputNumber';
import Cascader from '../VACascader/VACascader';
import SvgIcon from '../SvgIcon/SvgIcon';


export default /*@__PURE__*/_defineComponent({
  __name: 'VAForm',
  props: {
  data: {
    type: Object,
    required: true,
  },
  options: {
    type: Array as PropType<Array<VAFormItem>>,
    required: true,
    default: () => {
      return [];
    },
  },
},
  setup(__props, { expose: __expose }) {

const formRef = ref(null);

const components = {
  select: VASelect,
  'select-cascade': VASelectCascade,
  switch: VASwitch,
  'radio-group': VARadioGroup,
  'input-number': VAInputNumber,
  cascader: Cascader,
};

const props = __props;
const source = computed(() => props.data);

const rules = computed(() => {
  const data: {
    [key in string]: Array<{ required: boolean; message: string }>;
  } = {};
  (props.options as Array<VAFormItem>).forEach((item) => {
    if (item.required)
      data[item.key] = [{ required: true, message: `${item.label}不能为空` }];
  });
  return data;
});

__expose({
  source,
  formRef,
});

return (_ctx: any,_cache: any) => {
  const _component_a_tooltip = _resolveComponent("a-tooltip")!
  const _component_a_textarea = _resolveComponent("a-textarea")!
  const _component_a_input = _resolveComponent("a-input")!
  const _component_a_form_item = _resolveComponent("a-form-item")!
  const _component_a_form = _resolveComponent("a-form")!

  return (_openBlock(), _createBlock(_component_a_form, {
    model: source.value,
    "label-col": { span: 5 },
    "wrapper-col": { span: 18 },
    ref_key: "formRef",
    ref: formRef,
    rules: rules.value
  }, {
    default: _withCtx(() => [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.options, (item) => {
        return (_openBlock(), _createBlock(_component_a_form_item, {
          key: item.label,
          name: item.key,
          ref_for: true,
          ref: item.key
        }, _createSlots({
          label: _withCtx(() => [
            _createTextVNode(_toDisplayString(item.label) + " ", 1),
            (item.help)
              ? (_openBlock(), _createBlock(_component_a_tooltip, {
                  key: 0,
                  placement: "topLeft",
                  title: item.help
                }, {
                  default: _withCtx(() => [
                    _createVNode(_unref(SvgIcon), {
                      class: "va-form-help",
                      icon: "form-help",
                      height: "15px",
                      width: "15px"
                    })
                  ]),
                  _: 2
                }, 1032, ["title"]))
              : _createCommentVNode("", true)
          ]),
          default: _withCtx(() => [
            _createElementVNode("span", null, [
              (item.slot)
                ? _renderSlot(_ctx.$slots, item.slot, {
                    key: 0,
                    item: item,
                    data: source.value
                  })
                : (item.tagType in components)
                  ? (_openBlock(), _createBlock(_resolveDynamicComponent(components[item.tagType]), {
                      key: 1,
                      value: source.value[item.key],
                      "onUpdate:value": ($event: any) => ((source.value[item.key]) = $event),
                      size: item.size || 'small',
                      width: item.width || '100%',
                      options: item.options,
                      placeholder: item.placeholder || '请输入' + item.label,
                      disabled: item.disabled,
                      onOnChange: ($event: any) => (
              item.change ? item.change($event, source.value, item) : () => {}
            )
                    }, null, 40, ["value", "onUpdate:value", "size", "width", "options", "placeholder", "disabled", "onOnChange"]))
                  : (item.tagType === 'textarea')
                    ? (_openBlock(), _createBlock(_component_a_textarea, {
                        key: 2,
                        value: source.value[item.key],
                        "onUpdate:value": ($event: any) => ((source.value[item.key]) = $event),
                        disabled: item.disabled,
                        placeholder: item.placeholder || '请输入' + item.label,
                        rows: 4
                      }, null, 8, ["value", "onUpdate:value", "disabled", "placeholder"]))
                    : (_openBlock(), _createBlock(_component_a_input, {
                        key: 3,
                        value: source.value[item.key],
                        "onUpdate:value": ($event: any) => ((source.value[item.key]) = $event),
                        size: "small",
                        type: item.options?.type || 'text',
                        disabled: item.disabled,
                        width: item.width || '100%',
                        placeholder: item.placeholder || '请输入' + item.label,
                        suffix: item.options?.suffix,
                        prefix: item.options?.prefix
                      }, null, 8, ["value", "onUpdate:value", "type", "disabled", "width", "placeholder", "suffix", "prefix"]))
            ])
          ]),
          _: 2
        }, [
          (item.extra)
            ? {
                name: "extra",
                fn: _withCtx(() => [
                  _createTextVNode(_toDisplayString(item.extra), 1)
                ]),
                key: "0"
              }
            : undefined
        ]), 1032, ["name"]))
      }), 128))
    ]),
    _: 3
  }, 8, ["model", "rules"]))
}
}

})